import React from 'react';
import { IncidentAnalysis } from '../../types/incident';

interface RiskAssessmentProps {
    analysis: IncidentAnalysis;
}

const RiskAssessment: React.FC<RiskAssessmentProps> = ({ analysis }) => {
    if (!analysis.impact && !analysis.likelihood) return null;

    return (
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <h4 className="font-medium text-gray-900 mb-4">Risk Assessment</h4>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {analysis.impact && (
                    <div>
                        <span className="text-sm font-medium text-gray-700">Impact:</span>
                        <p className="text-sm text-gray-900 mt-1">{analysis.impact}</p>
                    </div>
                )}
                {analysis.likelihood && (
                    <div>
                        <span className="text-sm font-medium text-gray-700">Likelihood:</span>
                        <p className="text-sm text-gray-900 mt-1">{analysis.likelihood}</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default RiskAssessment;
